import { render } from "./cases-icon.vue?vue&type=template&id=37926f2d"
import script from "./cases-icon.vue?vue&type=script&lang=js"
export * from "./cases-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__